import { z } from 'zod';

export const promptRefinementAngleSchema = z.object({
  lens: z.string(),
  label: z.string(),
  depth: z.string(),
  time: z.string(),
  prompt: z.string(),
});
export type PromptRefinementAngle = z.infer<typeof promptRefinementAngleSchema>;

export const promptRefinementResponseSchema = z.object({
  angles: z.array(promptRefinementAngleSchema),
  clarification: z.string().nullable(),
});
export type PromptRefinementResponse = z.infer<
  typeof promptRefinementResponseSchema
>;

export const promptRefinement = {
  refinePrompt: {
    path: `prompt-refiner/v1/`,
    schema: promptRefinementResponseSchema,
  },
  refinePromptWithMentions: {
    path: `prompt-refiner/v2/`,
    schema: promptRefinementResponseSchema,
  },
};
